var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.665 26.4858C18.665 26.2432 18.7129 26.003 18.8062 25.7791C18.8997 25.5551 19.0363 25.3519 19.2087 25.1812C19.3811 25.0104 19.5856 24.8755 19.8103 24.7841C20.0351 24.6928 20.2755 24.6468 20.5182 24.649C20.8761 24.6555 21.2241 24.7672 21.5188 24.9704C21.8133 25.1736 22.0418 25.4593 22.175 25.7914C22.3083 26.1237 22.3404 26.4878 22.268 26.8382C22.1953 27.1887 22.021 27.51 21.7668 27.762C21.5126 28.0139 21.1898 28.1853 20.8387 28.2549C20.4876 28.3244 20.1237 28.2888 19.7927 28.1525C19.4616 28.0164 19.1782 27.7856 18.9776 27.4891C18.7771 27.1928 18.6683 26.8438 18.665 26.4858ZM19.2553 22.0086L19.0257 13.4478C19.0039 13.242 19.0257 13.0339 19.0896 12.8371C19.1534 12.6403 19.2579 12.459 19.3963 12.3052C19.5347 12.1513 19.704 12.0283 19.8929 11.9441C20.082 11.8599 20.2867 11.8164 20.4935 11.8164C20.7004 11.8164 20.9051 11.8599 21.0942 11.9441C21.2831 12.0283 21.4524 12.1513 21.5908 12.3052C21.7292 12.459 21.8337 12.6403 21.8975 12.8371C21.9614 13.0339 21.9832 13.242 21.9614 13.4478L21.7482 22.0086C21.7482 22.339 21.617 22.6562 21.3832 22.8899C21.1495 23.1236 20.8323 23.255 20.5018 23.255C20.1712 23.255 19.8542 23.1236 19.6205 22.8899C19.3868 22.6562 19.2553 22.339 19.2553 22.0086Z",
    fill: "#FFA500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 35.2599C28.8782 35.2599 35.6701 28.468 35.6701 20.0899C35.6701 11.7118 28.8782 4.91992 20.5001 4.91992C12.1219 4.91992 5.33008 11.7118 5.33008 20.0899C5.33008 28.468 12.1219 35.2599 20.5001 35.2599Z",
    stroke: "#FFA500",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.67b60cbb199f91b7668a9b0b92439a1a.svg";
export { ForwardRef as ReactComponent };